var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{ref:"dialogDom",staticClass:"aidraw-modal-container",attrs:{"isShow":true,"hiddenTitle":true},on:{"close":_vm.closeDialog}},[_c('iframe',{ref:"aidrawWin",attrs:{"src":_vm.url,"frameborder":"0"},on:{"load":_vm.aidrawWinLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }